import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiBuildings, PiUser } from 'react-icons/pi';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const LabelBaseStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  return (
    <LabelFormStep
      header={t('label.form.base.header')}
      description={t('label.form.base.description')}>
      <FormInput.Text
        name='labelName'
        label={t('input.label.name')}
        fullWidth
        borderless
        appBackground
      />
      <div />
      <div className='flex gap-4 w-full'>
        <Button
          fullWidth
          variant={BUTTON_VARIANT.background}
          isActive={formik.values.customerType === CUSTOMER_TYPE.Physical}
          onClick={() =>
            formik.setFieldValue('customerType', CUSTOMER_TYPE.Physical)
          }>
          <Button.Icon icon={<PiUser />} />

          <Button.Text
            text={t(
              `enum.CUSTOMER_TYPE.${CUSTOMER_TYPE[CUSTOMER_TYPE.Physical]}`
            )}
          />
        </Button>
        <Button
          fullWidth
          variant={BUTTON_VARIANT.background}
          isActive={formik.values.customerType === CUSTOMER_TYPE.Company}
          onClick={() =>
            formik.setFieldValue('customerType', CUSTOMER_TYPE.Company)
          }>
          <Button.Icon icon={<PiBuildings />} />
          <Button.Text
            text={t(
              `enum.CUSTOMER_TYPE.${CUSTOMER_TYPE[CUSTOMER_TYPE.Company]}`
            )}
          />
        </Button>
      </div>
    </LabelFormStep>
  );
};

export default LabelBaseStep;
